export default __webpack_public_path__ + "static/media/Pretendard-Light.subset.9a32e172.woff";